import DashboardIcon from "@mui/icons-material/Dashboard";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import TableViewIcon from "@mui/icons-material/TableView";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import AssessmentIcon from "@mui/icons-material/Assessment";
import EmailIcon from "@mui/icons-material/Email";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import BackupIcon from "@mui/icons-material/Backup";
import SecurityIcon from "@mui/icons-material/Security";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BadgeIcon from "@mui/icons-material/Badge";
import InsightsIcon from "@mui/icons-material/Insights";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HubIcon from "@mui/icons-material/Hub";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import ApiIcon from "@mui/icons-material/Api";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import StorageIcon from "@mui/icons-material/Storage";

const standardPlanFeatures = [
  {
    icon: <DashboardIcon fontSize="large" />,
    title: "Interactive Business Dashboard",
  },
  {
    icon: <Inventory2Icon fontSize="large" />,
    title: "Manage up to 100 Unique Items",
  },
  {
    icon: <PointOfSaleIcon fontSize="large" />,
    title: "Real-Time Point of Sale (POS)",
  },
  {
    icon: <PeopleIcon fontSize="large" />,
    title: "Supports up to 3 Users",
  },
  {
    icon: <BusinessIcon fontSize="large" />,
    title: "1 Business Location",
  },
  {
    icon: <WarehouseIcon fontSize="large" />,
    title: "1 Warehouse",
  },
  {
    icon: <StorefrontIcon fontSize="large" />,
    title: "1 POS Register",
  },
  {
    icon: <PeopleIcon fontSize="large" />,
    title: "Manage up to 500 Customers",
  },
  {
    icon: <PeopleIcon fontSize="large" />,
    title: "Manage up to 50 Suppliers",
  },
  {
    icon: <LocalOfferIcon fontSize="large" />,
    title: "Create up to 40 Barcode Labels",
  },
  {
    icon: <QrCode2Icon fontSize="large" />,
    title: "Create up to 40 QR Code Labels",
  },
  {
    icon: <PictureAsPdfIcon fontSize="large" />,
    title: "Export Reports to PDF",
  },
  {
    icon: <TableViewIcon fontSize="large" />,
    title: "Export Reports to Excel",
  },
  {
    icon: <DescriptionIcon fontSize="large" />,
    title: "Export Reports to CSV",
  },
  {
    icon: <AssessmentIcon fontSize="large" />,
    title: "Sales & Inventory Reports",
  },
  {
    icon: <EmailIcon fontSize="large" />,
    title: "Email Support",
  },
];

const professionalPlanFeatures = [
  {
    icon: <Inventory2Icon fontSize="large" />,
    title: "Manage up to 500 Unique Items",
  },
  {
    icon: <PeopleIcon fontSize="large" />,
    title: "Supports up to 6 Users",
  },
  {
    icon: <BusinessIcon fontSize="large" />,
    title: "Up to 2 Business Locations",
  },
  {
    icon: <WarehouseIcon fontSize="large" />,
    title: "Up to 2 Warehouses",
  },
  {
    icon: <StorefrontIcon fontSize="large" />,
    title: "Up to 4 POS Registers",
  },
  {
    icon: <LocalOfferIcon fontSize="large" />,
    title: "Create up to 200 Barcode Labels",
  },
  {
    icon: <QrCode2Icon fontSize="large" />,
    title: "Create up to 200 QR Code Labels",
  },
  {
    icon: <ShoppingCartIcon fontSize="large" />,
    title: "Purchase Management",
  },
  {
    icon: <LocalShippingIcon fontSize="large" />,
    title: "Manage up to 500 Suppliers",
  },
  {
    icon: <PeopleIcon fontSize="large" />,
    title: "Manage up to 5,000 Customers",
  },
  {
    icon: <SwapHorizIcon fontSize="large" />,
    title: "Stock Transfers Between Warehouses",
  },
  {
    icon: <AssessmentIcon fontSize="large" />,
    title: "Advanced Sales & Inventory Reports",
  },
  {
    icon: <BackupIcon fontSize="large" />,
    title: "7-Day Backup Retention",
  },
  {
    icon: <SecurityIcon fontSize="large" />,
    title: "Two-Factor Authentication (2FA)",
  },
  {
    icon: <SupportAgentIcon fontSize="large" />,
    title: "Live Chat, Phone & Email Support",
  },
];

const premiumPlanFeatures = [
  {
    icon: <Inventory2Icon fontSize="large" />,
    title: "Manage up to 2,000 Unique Items",
  },
  {
    icon: <PeopleIcon fontSize="large" />,
    title: "Supports up to 12 Users",
  },
  {
    icon: <BusinessIcon fontSize="large" />,
    title: "Up to 10 Business Locations",
  },
  {
    icon: <WarehouseIcon fontSize="large" />,
    title: "Up to 10 Warehouses",
  },
  {
    icon: <StorefrontIcon fontSize="large" />,
    title: "Up to 12 POS Registers",
  },
  {
    icon: <LocalOfferIcon fontSize="large" />,
    title: "Create up to 500 Barcode Labels",
  },
  {
    icon: <QrCode2Icon fontSize="large" />,
    title: "Create up to 500 QR Code Labels",
  },
  {
    icon: <PeopleIcon fontSize="large" />,
    title: "Manage up to 50,000 Customers",
  },
  {
    icon: <BusinessIcon fontSize="large" />,
    title: "Manage up to 5,000 Suppliers",
  },
  {
    icon: <AccountBalanceWalletIcon fontSize="large" />,
    title: "Complete Finance & Expense Management",
  },
  {
    icon: <BadgeIcon fontSize="large" />,
    title: "Staff Management & Role Control",
  },
  {
    icon: <AssessmentIcon fontSize="large" />,
    title: "Advanced Business & Financial Reports",
  },
  {
    icon: <InsightsIcon fontSize="large" />,
    title: "Business Analytics Dashboard",
  },
  {
    icon: <BackupIcon fontSize="large" />,
    title: "Automatic Backups with 30-Day Retention",
  },
  {
    icon: <HubIcon fontSize="large" />,
    title: "QuickBooks & Third-Party Integrations",
  },
  {
    icon: <AdminPanelSettingsIcon fontSize="large" />,
    title: "Custom Roles, Permissions & Two-Factor Authentication",
  },
  {
    icon: <SupportAgentIcon fontSize="large" />,
    title: "Priority Live Chat, Phone & Email Support",
  },
];

const enterprisePlanFeatures = [
  {
    icon: <Inventory2Icon fontSize="large" />,
    title: "Manage up to 15,000 Unique Items",
  },
  {
    icon: <AllInclusiveIcon fontSize="large" />,
    title: "Unlimited Users, Branches, Warehouses & POS Registers",
  },
  {
    icon: <AllInclusiveIcon fontSize="large" />,
    title: "Unlimited Customers, Suppliers & Label Generation",
  },
  {
    icon: <BusinessIcon fontSize="large" />,
    title: "Multi-Branch & Multi-Company Management",
  },
  {
    icon: <LocalOfferIcon fontSize="large" />,
    title: "Unlimited Barcode Labels",
  },
  {
    icon: <QrCode2Icon fontSize="large" />,
    title: "Unlimited QR Code Labels",
  },
  {
    icon: <ApiIcon fontSize="large" />,
    title: "Developer API Access (100,000 Requests/Day)",
  },
  {
    icon: <HubIcon fontSize="large" />,
    title: "Webhooks, QuickBooks & Third-Party Integrations",
  },
  {
    icon: <InsightsIcon fontSize="large" />,
    title: "Advanced Business Analytics & Executive Reports",
  },
  {
    icon: <FactCheckIcon fontSize="large" />,
    title: "Audit Logs & Compliance Reporting",
  },
  {
    icon: <SecurityIcon fontSize="large" />,
    title:
      "Enterprise Security (SSO, IP Restrictions & Two-Factor Authentication)",
  },
  {
    icon: <AdminPanelSettingsIcon fontSize="large" />,
    title: "Advanced Roles, Permissions & Session Management",
  },
  {
    icon: <BackupIcon fontSize="large" />,
    title: "Automatic Backups with 365-Day Retention",
  },
  {
    icon: <StorageIcon fontSize="large" />,
    title: "100 GB Secure Cloud Storage",
  },
  {
    icon: <SupportAgentIcon fontSize="large" />,
    title: "Dedicated Account Manager & Priority 24/7 Support",
  },
];

export const featuresArray = [
  {
    slug: "standard",
    features: standardPlanFeatures,
  },
  {
    slug: "professional",
    features: professionalPlanFeatures,
    discription: "Everything in Standard plus",
  },
  {
    slug: "premium",
    features: premiumPlanFeatures,
    discription: "Everything in Professional plus",
  },
  {
    slug: "enterprise",
    features: enterprisePlanFeatures,
    discription: "Everything in Premium plus",
  },
];
